import React from 'react';
import PropTypes from 'prop-types';

const Strings = require('../../../../../app/shared/Strings');

const propTypes = {
	id: PropTypes.string.isRequired,
	selectedMinVersion: PropTypes.string,
	selectedMaxVersion: PropTypes.string,
	onChangeMinVersion: PropTypes.func.isRequired,
	onChangeMaxVersion: PropTypes.func.isRequired,
	versionRanges: PropTypes.object.isRequired,
	separator: PropTypes.string,
};

const defaultProps = {
	selectedMinVersion: '-1',
	selectedMaxVersion: '-1',
	versionRanges: {},
};

function VersionRangeSelector(props) {
	const availableMinVersions = Object.keys(props.versionRanges);
	const availableMaxVersions = props.versionRanges[props.selectedMinVersion] || [];
	return (
		<span id={props.id}>
            <select value={props.selectedMinVersion} onChange={props.onChangeMinVersion}>
            	{(availableMinVersions.length === 0) &&
	                <option value="-1" disabled>{Strings['en'].activity.qla.VER_NONE}</option>
            	}
                {availableMinVersions.map((minVersion) =>
                    <option key={`p-${minVersion}`} value={minVersion}>{minVersion}</option>
                )}
            </select>
            <span className="margin-left-md margin-right-md">
	            {Strings['en'].activity.qla.RANGE_TO}
	        </span>
            <select value={props.selectedMaxVersion} onChange={props.onChangeMaxVersion}>
            	{(availableMaxVersions.length === 0) &&
	                <option value="-1" disabled>{Strings['en'].activity.qla.VER_NONE}</option>
	            }
                {availableMaxVersions.map((maxVersion) =>
                    <option key={`p-${maxVersion}`} value={maxVersion}>{maxVersion}</option>
                )}
            </select>
		</span>
	);
}

VersionRangeSelector.propTypes = propTypes;
VersionRangeSelector.defaultProps = defaultProps;

export default VersionRangeSelector;